export default __webpack_public_path__ + "static/media/atusd.58decb0d.svg";